import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { JobExecution } from '@features/cron/types'

export function useScheduledTaskExecutions(id?: string) {
  async function getExecutions(): Promise<JobExecution[]> {
    const res = await apiClient.get<JobExecution[]>(
      `${BACK_OFFICE_PREFIX}scheduled-tasks/${id}/executions`
    )
    return res.data
  }

  return useQuery({
    queryFn: getExecutions,
    queryKey: ['scheduled-task', id, 'executions'],
    enabled: !!id
  })
}
